import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserRoleDict } from 'app/core/data/user-type-roles';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  // Check the authentication status

  return authService.check().pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const redirectURL =
          state.url === '/sign-out'
            ? ''
            : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

        return of(urlTree);
      }
      // If authenticated, check if user.roleId is 0
      const user = authService.loggedUser; // Get the loggedUser from AuthService
      const userRole = UserRoleDict[user.roleId];
      const allowed = true;//userRole === 'Master';
      // If roleId is not 0, redirect to an unauthorized page or access denied page
      if (!allowed) {
        const urlTree = router.parseUrl('/sign-in');
        return of(urlTree);
      }

      // Allow the access
      return of(true);
    })
  );
};
